const PANORAMA_ID = 'pid';

const getSearch = () => window.location
    .search
    .split(/(\?|=|&)/)
    .filter((a) => !!a && a !== '?');

const getValue = (a, i) => a[i + 2];

const getPath = () => window.location.href.split('?')[0];

export const getCoordinate = () => {
  const search = getSearch();
  const lat = parseFloat(getValue(search, search.indexOf('lat')));
  const lng = parseFloat(getValue(search, search.indexOf('lng')));

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return { lat: 30, lng: 15 };
  }

  return { lat, lng };
};

export const getSelectedArea = () => {
  const search = getSearch();
  const lat = parseFloat(getValue(search, search.indexOf('alat')));
  const lng = parseFloat(getValue(search, search.indexOf('alng')));
  const radius = parseFloat(getValue(search, search.indexOf('arad')));

  if (Number.isNaN(lat) || Number.isNaN(lng) || Number.isNaN(radius)) {
    return null;
  }

  return { lat, lng, radius };
};

export const getMode = () => {
  const search = getSearch();
  const mode = getValue(search, search.indexOf('mode'));
  const id = getValue(search, search.indexOf(PANORAMA_ID));

  return mode === 'panorama' && id ? 'panorama' : 'map';
};

export const getPanoramaId = () => {
  const search = getSearch();
  const i = search.indexOf(PANORAMA_ID);

  return i === -1 ? '' : getValue(search, i);
};

export const getZoom = () => {
  const search = getSearch();
  const zoom = parseFloat(getValue(search, search.indexOf('zoom')));

  return Number.isNaN(zoom) ? 3 : zoom;
};

export const getCameraRotation = () => {
  const search = getSearch();
  const x = parseFloat(getValue(search, search.indexOf('rx')));
  const y = parseFloat(getValue(search, search.indexOf('ry')));
  const z = parseFloat(getValue(search, search.indexOf('rz')));

  return Number.isNaN(x) || Number.isNaN(y) || Number.isNaN(z) ? null : {
    x, y, z,
  };
};

export const updateUrl = ({
  map,
  ui,
  panorama,
}, replaceState = false) => {
  const { coordinate, zoom, selectedArea } = map;
  const { id, rotation } = panorama;
  const { isMapUi } = ui;
  const { lat, lng } = coordinate;
  const mode = isMapUi ? 'map' : 'panorama';

  let url = `${getPath()}?mode=${mode}&lat=${lat}&lng=${lng}&zoom=${zoom}`;
  url += id ? `&${PANORAMA_ID}=${id}` : '';

  if (selectedArea != null) {
    const { lat: alat, lng: alng, radius } = selectedArea;
    url += `&alat=${alat}&alng=${alng}&arad=${radius}`;
  }

  if (rotation !== null) {
    const { x, y, z } = rotation;
    url += `&rx=${x}&ry=${y}&rz=${z}`;
  }

  if (replaceState) {
    window.history.replaceState(null, '', url);
  } else {
    window.history.pushState(null, '', url);
  }
};

export default () => window.location.href;
